import React, { useEffect, useState } from "react";
import logo from "../../../../assets/img/posLogo.svg";
import globalIcon from "../../../../assets/img/globalIcon.svg";
import { useHistory } from "react-router-dom";
import registerLoginIcon from "../../../../assets/img/registerAndLoginIcon.svg";
import itemsIcon from "../../../../assets/img/itemsImage.svg";
import saleIcon from "../../../../assets/img/saleIcon.svg";
import invoicesIcon from "../../../../assets/img/invoicesIcon.svg";
import customerIcon from "../../../../assets/img/customersIcon.svg";
import reportsIcon from "../../../../assets/img/reportsIcon.svg";
import settingsIcon from "../../../../assets/img/settingsIcon.svg";
import companyIcon from "../../../../assets/img/companyIcon.svg";
import googlePlay from "../../../../assets/img/GooglePlay.svg";
import tiktokIcon from "../../../../assets/img/light-tiktok-icon.svg";
import twitterIcon from "../../../../assets/img/light-twitter-icon.svg";
import snapchatIcon from "../../../../assets/img/light-snapchat-icon.svg";
import fbIcon from "../../../../assets/img/light-facebook-icon.svg";
import instaIcon from "../../../../assets/img/light-insta-icon.svg";
import YtIcon from "../../../../assets/img/light-youtube-icon.svg";
import logoWhite from "../../../../assets/img/logo_white.svg";
import searchIcon from "../../../../assets/img/company/SearchIcon.svg";
import HelpCards from "../components/HelpCards";
import HelpBreadCrumbs from "../components/HelpBreadCrumbs";
import RegistrationHelpDetails from "../components/help-sections/RegistrationHelpDetails";
import axios from "axios";
import { Helmet } from "react-helmet";
import { GOOGLE_PLAY_URL, socialLinks } from "../../../../helpers/constants";
import { trackAppClick, trackVisit } from "../../../../helpers/analyticsTracking";

function HelpPage() {
  const [screenSize, setScreenSize] = useState(window.innerWidth);
  const [allHelpPages, setAllHelpPages] = useState([]);
  useEffect(() => {
    const handleResize = () => {
      setScreenSize(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const selectedLanguage = localStorage.getItem("language");
  const history = useHistory();

  const handleChangeLanguage = () => {
    let language = selectedLanguage === "english" ? "arabic" : "english";
    localStorage.setItem("language", language);
    window.location.reload();
  };
  const HELP_TOPIC_CARDS = [
    {
      name: "Registration & Login",
      arabicName: "التسجيل والدخول",
      img: registerLoginIcon,
      link: "Registration & Login",
    },
    {
      name: "Items",
      arabicName: "العناصر",
      img: itemsIcon,
      link: "Items",
    },
    {
      name: "Sale",
      arabicName: "البيع",
      img: saleIcon,
      link: "Sale",
    },
    {
      name: "Invoices",
      arabicName: "الفواتير",
      img: invoicesIcon,
      link: "Invoices",
    },
    {
      name: "Customer",
      arabicName: "العملاء",
      img: customerIcon,
      link: "Customer",
    },
    {
      name: "Reports",
      arabicName: "التقارير",
      img: reportsIcon,
      link: "Reports",
    },
    {
      name: "Company",
      arabicName: "الشركة",
      img: companyIcon,
      link: "Company",
    },
    {
      name: "Settings",
      arabicName: "الاعدادت",
      img: settingsIcon,
      link: "Settings",
    },
  ];

  const getSelectedModule = () => {
    let pathLocation = window?.location?.href?.split("/")?.pop();
    if (pathLocation?.includes("help?topic=")) {
      return "topicSection";
    } else if (pathLocation?.includes("help?detail=")) {
      return "topicDetails";
    } else return "help";
  };

  const handleClickTopic = (topic) => {
    history.push(`/help?topic=${topic}`);
  };
  const handleClickBack = () => {
    history.push("/help");
  };
  const handleClickNext = (name) => {
    history.push(`/help?detail=${name}`);
  };

  const getHelpPages = async () => {
    await axios.get(`/api/content?type=help`).then((res) => {
      let allHelpPages = res?.data?.data?.results;
      let refactoredData = allHelpPages
        // ?.filter((item) => !item?.helpContent?.isDeleted)
        ?.map((item) => {
          return {
            ...item,
            pageName: item?.helpContent?.pageName,
            sectionName: item?.helpContent?.sectionName,
            arabicPageName: item?.helpContent?.arabicPageName,
          };
        });
      setAllHelpPages(refactoredData);
    });
  };
  useEffect(() => {
    getHelpPages();
  }, []);

  let selectedSection = window?.location?.href
    ?.split("/")
    ?.pop()
    ?.split("=")
    ?.pop();

  const pageTitle =
    getSelectedModule() === "topicDetails"
      ? selectedLanguage === "arabic"
        ? "تفاصيل المساعدة | فاتورتي"
        : "Help Details | Fatoraty"
      : getSelectedModule() === "topicSection"
      ? selectedLanguage === "arabic"
        ? "قسم المساعدة | فاتورتي"
        : "Help Section | Fatoraty"
      : selectedLanguage === "arabic"
      ? "مركز المساعدة | فاتورتي"
      : "Help Center | Fatoraty";

  const pageDescription = selectedLanguage === "arabic" ? "مركز المساعدة والدعم الخاص بمنصة فاتورتي" : "Fatoraty help center and support pages.";

  useEffect(() => {
    trackVisit();
  }, []);

  const handlePosDownloadClick = () => {
    trackAppClick();
  };
  return (
    <div className="w-100">
      <Helmet>
        <html lang={selectedLanguage === "arabic" ? "ar" : "en"} />

        <title>{pageTitle}</title>

        <meta name="description" content={pageDescription} />

        <meta property="og:title" content={pageTitle} />

        <meta property="og:description" content={pageDescription} />

        <link rel="canonical" href={window?.location?.href} />
      </Helmet>
      <div
        className="w-100"
        style={{
          position: "fixed",
          top: "0",
          paddingTop: screenSize > 550 ? "1rem" : "1rem",
          background: "#FFFFFF",
          zIndex: "10",
          boxShadow: "0px 2px 4px 0px #00000040",
        }}
      >
        <div
          className="home-pageheader pt-2 pb-4"
          style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 18px", direction: selectedLanguage === "arabic" ? "rtl" : "ltr" }}
        >
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <img className="home-logo cursor-pointer" width={"160px"} src={logo} alt="logo" onClick={() => history.push("/homePage")} />
            </div>
            <div>
              {/* {screenSize > 1200 ? ( */}
              <div
                className="d-flex mt-3 cursor-pointer"
                style={{ alignItems: "center", position: "relative", bottom: "6px" }}
                onClick={handleChangeLanguage}
              >
                <span
                  className={`${selectedLanguage === "english" ? "mr-1" : "ml-1"}`}
                  style={{ fontWeight: "400", fontSize: "16px", color: "#4F4F4F" }}
                >
                  {selectedLanguage === "english" ? "العربية" : "English"}
                </span>
                <img src={globalIcon} alt="global" />
              </div>
              {/* ) : null} */}
            </div>
          </div>
        </div>
      </div>

      <div className="w-100 benefits-wrapper" style={{ marginTop: "6.2rem", background: "#2D9CDB" }}>
        <div
          className="d-flex flex-column justify-content-center align-items-center"
          style={{ paddingTop: "3rem", paddingBottom: screenSize > 600 ? "2rem" : "3rem" }}
        >
          <p className="help-main-text" style={{ fontSize: screenSize > 600 ? "30px" : "20px" }}>
            {selectedLanguage === "arabic" ? "مرحبا, كيف أقدر أساعدك؟" : "Hello, how can I help you?"}
          </p>
          <div
            className={`mt-5 position-relative ${screenSize > 600 ? "px-0" : "px-4"}`}
            style={{ minWidth: screenSize > 600 ? "564px" : "100%", width: "auto", fontWeight: 500, fontSize: "16px", color: "#828282" }}
          >
            <input
              className={`w-100 py-4 pl-4 ${selectedLanguage === "arabic" ? "pr-4" : "pl-4"}`}
              style={{
                outline: "none",
                paddingRight: selectedLanguage === "english" && "2.7rem",
                paddingLeft: selectedLanguage === "arabic" && "2.7rem",
                direction: selectedLanguage === "arabic" ? "rtl" : "ltr",
              }}
              type="text"
              placeholder={selectedLanguage === "arabic" ? "بحث" : "Search"}
            />
            <img
              style={{
                position: "absolute",
                top: "1.3rem",
                right: selectedLanguage === "english" && (screenSize > 600 ? "1rem" : "2rem"),
                left: selectedLanguage === "arabic" && (screenSize > 600 ? "1rem" : "2rem"),
              }}
              src={searchIcon}
              alt="search"
            />
          </div>
        </div>
      </div>
      {getSelectedModule() === "topicSection" ? (
        <>
          <div className="w-100 bg-white">
            <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 18px", direction: selectedLanguage === "arabic" ? "rtl" : "ltr" }}>
              <div className="py-5">
                <HelpBreadCrumbs
                  moduleName={selectedSection}
                  pagesData={allHelpPages}
                  screenSize={screenSize}
                  handleClickBack={handleClickBack}
                  selectedLanguage={selectedLanguage}
                  handleClickNext={handleClickNext}
                />
              </div>
            </div>
          </div>
        </>
      ) : getSelectedModule() === "topicDetails" ? (
        <>
          <div className="bg-white">
            <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 18px", direction: selectedLanguage === "arabic" ? "rtl" : "ltr" }}>
              {/* {screenSize > 1200 ? (
                <div className="d-flex position-relative " style={{ gap: "2rem" }}>
                  <div style={{ minWidth: "225px" }}>
                    <HelpSideNavigator />
                  </div>
                  <RegistrationHelpDetails isDesktop={true} />
                </div>
              ) : ( */}
              <div className="">
                <div className="pt-5">
                  <HelpBreadCrumbs
                    moduleName={selectedSection}
                    pagesData={allHelpPages}
                    screenSize={screenSize}
                    handleClickBack={handleClickBack}
                    selectedLanguage={selectedLanguage}
                    handleClickNext={handleClickNext}
                    showFullDetails={false}
                    handleClickTopic={handleClickTopic}
                  />
                </div>
                <RegistrationHelpDetails isDesktop={false} />
              </div>
              {/* )} */}
            </div>
          </div>
        </>
      ) : (
        <>
          <HelpCards
            HELP_TOPIC_CARDS={HELP_TOPIC_CARDS}
            screenSize={screenSize}
            selectedLanguage={selectedLanguage}
            handleClickTopic={handleClickTopic}
          />
          <div className="w-100 bg-white">
            <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 18px", direction: selectedLanguage === "arabic" ? "rtl" : "ltr" }}>
              <div className="pt-5" style={{ paddingBottom: "4rem" }}>
                <p className="text-center py-5" style={{ color: "#333333", fontSize: screenSize > 600 ? "30px" : "16px" }}>
                  {selectedLanguage === "arabic" ? "قم بتحميل نسختك المجانية من تطبيق فاتورتي POS" : "Download your free copy of Fatoraty POS App"}
                </p>
                <div
                  className={`d-flex justify-content-center align-items-center ${selectedLanguage === "arabic" ? "flex-row-reverse" : "flex-row"}`}
                  style={{ gap: "1rem" }}
                >
                  <a href={GOOGLE_PLAY_URL} target="_blank" rel="noopener noreferrer" onClick={handlePosDownloadClick}>
                    <img width={"138px"} src={googlePlay} alt="google" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {/* footer */}
      {getSelectedModule() === "topicSection" ? null : (
        <div className="w-100" style={{ background: "#2D9CDB", paddingTop: "3rem", paddingBottom: "3rem" }}>
          <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 18px", direction: selectedLanguage === "arabic" ? "rtl" : "ltr" }}>
            <div>
              {screenSize > 600 ? (
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex justify-content-center" style={{ gap: "30px" }}>
                    <div className="mx-auto my-auto text-white" style={{ fontSize: "16px" }}>
                      Fatoraty 2025
                    </div>

                    <a href={socialLinks.tiktok} target="_blank" rel="noopener noreferrer">
                      <img src={tiktokIcon} alt="tiktok" />
                    </a>
                    <a href={socialLinks.youtube} target="_blank" rel="noopener noreferrer">
                      <img src={YtIcon} alt="youtube" />
                    </a>
                    <a href={socialLinks.instagram} target="_blank" rel="noopener noreferrer">
                      <img src={instaIcon} alt="instagram" />
                    </a>
                    <a href={socialLinks.facebook} target="_blank" rel="noopener noreferrer">
                      <img src={fbIcon} alt="facebook" />
                    </a>
                    <a href={socialLinks.x} target="_blank" rel="noopener noreferrer">
                      <img src={twitterIcon} alt="twitter" />
                    </a>
                    <a href={socialLinks.snapchat} target="_blank" rel="noopener noreferrer">
                      <img src={snapchatIcon} alt="snapchat" />
                    </a>
                  </div>
                  <div className="d-flex justify-content-center">
                    <img className="home-logo" width={"160px"} src={logoWhite} alt="logo" />
                  </div>
                </div>
              ) : (
                <div className="d-flex flex-column">
                  <div className="d-flex justify-content-between">
                    <div className=" my-auto text-white" style={{ fontSize: "16px" }}>
                      Fatoraty 2025
                    </div>
                    <div className="">
                      <img className="home-logo" width={"160px"} src={logoWhite} alt="logo" />
                    </div>
                  </div>

                  <div className="d-flex justify-content-center" style={{ gap: "30px", marginTop: "2rem" }}>
                    <a href={socialLinks.tiktok} target="_blank" rel="noopener noreferrer">
                      <img src={tiktokIcon} alt="tiktok" />
                    </a>
                    <a href={socialLinks.youtube} target="_blank" rel="noopener noreferrer">
                      <img src={YtIcon} alt="youtube" />
                    </a>
                    <a href={socialLinks.instagram} target="_blank" rel="noopener noreferrer">
                      <img src={instaIcon} alt="instagram" />
                    </a>
                    <a href={socialLinks.facebook} target="_blank" rel="noopener noreferrer">
                      <img src={fbIcon} alt="facebook" />
                    </a>
                    <a href={socialLinks.x} target="_blank" rel="noopener noreferrer">
                      <img src={twitterIcon} alt="twitter" />
                    </a>
                    <a href={socialLinks.snapchat} target="_blank" rel="noopener noreferrer">
                      <img src={snapchatIcon} alt="snapchat" />
                    </a>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default HelpPage;
